// supportStyles.js
const styles = {
    container: {
        backgroundColor: '#ffffff',
        padding: '20px',
        marginTop: '20px',
        marginBottom: '20px',
        borderRadius: '5px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    header: {
        marginBottom: '20px',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    button: {
        marginRight: '10px',
        backgroundColor: '#22619d',
        color: '#efefef',
    },
    disabledButton: {
        backgroundColor: '#d3d3d3',
        color: '#a9a9a9',
        cursor: 'not-allowed',
    },
    datePicker: {
        marginLeft: 'auto',
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#22619d',
            },
            '&:hover fieldset': {
                borderColor: '#22619d',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#22619d',
            },
        },
    },
    select: {
        minWidth: '150px',
        width: '200px',
    },
};

export default styles;
